// import React, { FC, useRef } from 'react'
// import { useRouter } from 'next/router'
// import { useGetPublicToysInfinity } from '@hooks/TRPC_Hooks/useGetToys'
// import { InfinityList } from '@components/InfinityList/InfinityList'
// import { getToysSortQuery, PageQueries } from '@specs/navigation'
// import { ToyCard } from '@components/Cards/ToyCard/ToyCard'

// interface Props { }

// const limit = 10

// export const ToysPublicList: FC<Props> = ({ }) => {
//     const router = useRouter()
//     const enabledRef = useRef(false)
//     const { toysSort, query, priceSortCurrency, toysRarity }: PageQueries = router.query

//     const sort = getToysSortQuery(toysSort)

//     const {
//         data,
//         fetchNextPage,
//         hasNextPage,
//         isFetchingNextPage,
//         status,
//     } = useGetPublicToysInfinity({
//         limit,
//         sort,
//         query,
//         rarity: toysRarity,
//         currency: priceSortCurrency,
//     }, {
//         enabled: enabledRef.current,
//     })

//     return (
//         <InfinityList
//             fetchNextPage={fetchNextPage}
//             data={data}
//             hasNextPage={hasNextPage}
//             isFetchingNextPage={isFetchingNextPage}
//             status={status}
//             enabledRef={enabledRef}
//             listClassName={'_toysGrid'}
//         >
//             {(item) => (
//                 <ToyCard
//                     key={item.id}
//                     {...item}
//                 />
//             )}
//         </InfinityList>
//     )
// }

import React, { FC, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { useGetPublicToys } from '@hooks/TRPC_Hooks/useGetToys';
import { getToysSortQuery, PageQueries } from '@specs/navigation';
import { ToyCard } from '@components/Cards/ToyCard/ToyCard';
import { PaginatedList } from '@components/PaginatedList/PaginatedList';
interface Props {}
const limit = 10;
export const ToysPublicList: FC<Props> = () => {
  const router = useRouter();
  const gridRef = useRef<HTMLDivElement>(null);
  const {
    toysSort,
    query,
    priceSortCurrency,
    toysRarity,
    page = '1'
  }: PageQueries = router.query;
  const currentPage = Number(page);
  const prevPageRef = useRef<number>(currentPage);
  const pageChangeRef = useRef(false);
  const sort = getToysSortQuery(toysSort);
  const {
    data,
    status
  } = useGetPublicToys({
    limit,
    skip: (currentPage - 1) * limit,
    sort,
    query,
    rarity: toysRarity,
    currency: priceSortCurrency
  });
  const handlePageChange = (newPage: number) => {
    pageChangeRef.current = true;
    router.push({
      query: {
        ...router.query,
        page: newPage.toString()
      }
    }, undefined, {
      scroll: false
    });
  };
  useEffect(() => {
    if (currentPage !== prevPageRef.current) {
      pageChangeRef.current = true;
      prevPageRef.current = currentPage;
    }
    if (pageChangeRef.current && status === 'success' && data?.items.length) {
      if (gridRef.current) {
        window.scrollTo({
          top: gridRef.current.offsetTop - 100,
          behavior: 'smooth'
        });
      }
      pageChangeRef.current = false;
    }
  }, [currentPage, status, data]);
  return <div ref={gridRef} data-sentry-component="ToysPublicList" data-sentry-source-file="ToysPublicList.tsx">
            <PaginatedList data={data} currentPage={currentPage} onPageChange={handlePageChange} status={status} listClassName="_toysGrid" data-sentry-element="PaginatedList" data-sentry-source-file="ToysPublicList.tsx">
            {item => <ToyCard key={item.id} {...item} />}
            </PaginatedList>
        </div>;
};